<div class="date-filter__field" [ngClass]="{'date-filter__field-disabled': disabled}">
  @if(showCalendarDrop) {
  
    @if(disabled){
      <div class="date-filter__date">
        @if(isMonthPeriod()){
          {{fromCalendar.selected | date: 'MMMM yyyy'}} - {{toCalendar.selected | date: 'MMMM yyyy'}}
        }
        @else {
          {{fromCalendar.selected | date: 'd MMMM yyyy'}} - {{toCalendar.selected | date: 'd MMMM yyyy'}}
        }
      </div>
    }
    @else{ <!--not disabled-->
      <button 
      [matMenuTriggerFor]="menuTrigger" 
      mat-button #menuButton 
      (menuClosed)="onMenuClose($event)"
      (menuOpened)="onMenuOpen($event)">
        <div class="date-filter__date">
          @if(isMonthPeriod()){
            {{fromCalendar.selected | date: 'MMMM yyyy'}} - {{toCalendar.selected | date: 'MMMM yyyy'}}
          }
          @else {
            {{fromCalendar.selected | date: 'd MMMM yyyy'}} - {{toCalendar.selected | date: 'd MMMM yyyy'}}
          }
        </div>
        @if(showCalendarIcon){
          <svg class="date-filter__icon">
            <use xlink:href="#baseline-date_range-24px" href="#baseline-date_range-24px" />
          </svg>
        }
      </button>
    }
  }

  @if(!showCalendarDrop) { 
    <button 
      [matMenuTriggerFor]="menuTrigger" 
      #menuButton 
      (menuClosed)="onMenuClose($event)"
      (menuOpened)="onMenuOpen($event)" 
      class="sx-table-filter__button sx-table-filter__button--drop sx-button-stripped">
      <span>{{ selectedPeriod }}</span>
      <svg>
        <use xlink:href="#baseline-arrow_drop_down-24px" href="#baseline-arrow_drop_down-24px" />
      </svg>
  </button>
  }
</div>

<mat-menu #menuTrigger="matMenu" yPosition="below" overlapTrigger="false" xPosition="after" class="double-cal">
  <div class="date-filter-panel">
    <div class="date-filter-panel-calendars">
      <div class="date-filter-panel-calendars-content">
        <div class="date-filter-panel-calendars-content__title">{{'core.datefilter.from'|translate}}</div>
        <div class="date-filter-panel-calendars-content__calendar">
          <app-sx-calendar (click)="$event.stopPropagation()" (selectedChange)="selectedFromChange($event)"
            [disableMonthView]="isMonthPeriod()" #fromCalendar [headerComponent]="headerFrom"></app-sx-calendar>
        </div>
      </div>
      <div class="date-filter-panel-calendars-content">
        <div class="date-filter-panel-calendars-content__title">{{'core.datefilter.to'|translate}}</div>
        <div class="date-filter-panel-calendars-content__calendar">
          <app-sx-calendar (click)="$event.stopPropagation()" (selectedChange)="selectedToChange($event)"
            [disableMonthView]="isMonthPeriod()" #toCalendar [headerComponent]="headerTo"></app-sx-calendar>
        </div>
      </div>
      <div hidden="true">
        <mat-calendar></mat-calendar>
      </div>
    </div>
    @if(allowClear){
      <div class="date-filter-panel__bar sxl-grow">
        <button mat-button (click)="clearAll()" class="date-filter-panel__button date-filter-panel__button--reset">
          <div class="date-filter-panel__button--padding">
            <svg>
              <use xlink:href="#baseline-settings_backup_restore-24px" href="#baseline-settings_backup_restore-24px" />
            </svg>
            {{'core.filter.clear-value'|translate}}
          </div>
        </button>
      </div>
    }

  </div>
</mat-menu>